<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { listMenu, listContentInfo, listInfo, ChangeCheck } from '../../../api/46';
import zhuye from '@/assets/zhuye.png'
import { exportAssetPdf } from '@/views/crmreport/46report/i.js'
export default {
  components: {},
  data() {
    return {
      Menu: {},
      Menu1: {},
      Menu2: {},
      Menu3: {},
      completeChecked:'',
      checked: '1',
      infoId: '',
      Menu4: {},
      Menu5: {},
      zhuye,
      a: [],
      airRoom: {},
      postInfo: [],
      review: {},
      airCompInfo: {},
      customerInfo: {},
      pic: [],
      shuju: {
        runInfo: [],
        customerInfo: {},
        airCompInfo: {}
      },
      dis:false,
      sh: this.$t('report46.audit')
    };
  },
  methods: {
    printOut(DomName) {
      DomName = document.getElementById(DomName)
      window.pageYoffset = 0; // 滚动置顶
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      //title，随意设置，也可以提出来做参数，传入进来，自己发挥
      var title = this.$t('report46.exportTitle'); // 导出名字
      var that = this;
      var shareContent = DomName; //需要截图的包裹的（原生的）DOM 对象
      //打印看有没有获取到dom
      console.log(shareContent);
      var width = shareContent.offsetWidth; //获取dom 宽度
      var height = shareContent.offsetHeight; //获取dom 高度
      var canvas = document.createElement("canvas"); //创建一个canvas节点
      var scale = 2; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放，在此我是把canvas放大了2倍
      canvas.height = height * scale; //定义canvas高度 *缩放
      canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
      html2Canvas(DomName, {
        //允许跨域图片的加载
        useCORS: true,
        dpi: window.devicePixelRatio * 3, //将分辨率提高到特定的DPI 提高四倍
        // scale: 2, //按比例增加分辨率
      }).then(function (canvas) {
        var context = canvas.getContext("2d");
        // 【重要】关闭抗锯齿
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        var imgData = canvas.toDataURL("image/", 1.0); //转化成base64格式,可上网了解此格式
        var img = new Image();
        img.src = imgData;
        img.onload = function () {
          img.width = img.width / 2; //因为在上面放大了2倍，生成image之后要/2
          img.height = img.height / 2;
          img.style.transform = "scale(0.5)";
          if (this.width > this.height) {
            //此可以根据打印的大小进行自动调节
            var doc = new JsPDF("l", "mm", [
              this.width * 0.555,
              this.height * 0.555
            ]);
          } else {
            var doc = new JsPDF("p", "mm", [
              this.width * 0.555,
              this.height * 0.555
            ]);
          }
          doc.addImage(
            imgData,
            "jpeg",
            10,
            0,
            this.width * 0.505,
            this.height * 0.545
          );
          doc.save(title + "-" + this.$t('repoert46.file') + ".pdf");
        };
      });
    },
    r(r) {
      return r.replaceAll(/\n/g, '<br>')
    },
    change11(e) {
      console.log(e);
    },
    g() {
      exportAssetPdf('11', 'pdfDom')
    },
    async ListC() {
      const result = await listMenu()
      console.log(result);
      if (result.code == 0) {

        for (let i = 0; i < result.data.length; i++) {
          for (let j = 0; j < result.data[i].child.length; j++) {
            let kong = {}
            for (let k = 0; k < result.data[i].child[j].child.length; k++) {
              if (!kong[result.data[i].child[j].child[k].row]) {
                kong[result.data[i].child[j].child[k].row] = []

              }
              result.data[i].child[j].child[k].selectList = []
              result.data[i].child[j].child[k].radioList = ''
              if (result.data[i].child[j].child[k].menuType == '1' && this.shuju[result.data[i].child[j].propertyName][result.data[i].child[j].child[k].propertyName]) {
                result.data[i].child[j].child[k].selectList = this.shuju[result.data[i].child[j].propertyName][result.data[i].child[j].child[k].propertyName].split(',').map(i => +i)
              }
              if (result.data[i].child[j].child[k].menuType == '0') {
                result.data[i].child[j].child[k].radioList = +this.shuju[result.data[i].child[j].propertyName][result.data[i].child[j].child[k].propertyName]
              }
              kong[result.data[i].child[j].child[k].row].push(result.data[i].child[j].child[k])

            }
            result.data[i].child[j].render = kong
          }
        }
        this.Menu = result.data
        this.Menu1 = this.Menu[0]
        this.Menu2 = this.Menu[1]
        this.Menu3 = this.Menu[2]
        this.Menu4 = this.Menu[3]
        this.Menu5 = this.Menu[4]
        console.log(this.Menu);
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },

    async change() {
      const formdata = new FormData()
      formdata.append('infoId',this.infoId)
      formdata.append('completeChecked',this.completeChecked)
      const result = await ChangeCheck(formdata)
      console.log(result);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        this.checked = '1'
        if(this.checked=='1'){
      this.dis = true
      this.sh = this.$t('report46.audited')
    }else{
      this.dis = false
      this.sh = this.$t('report46.audit')
    }
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }

    }
  },
  async created() {
    console.log(this.$route.query.id);
    this.infoId = this.$route.query.id
    this.checked = this.$route.query.checked
    if(this.checked=='1'){
      this.dis = true
      this.sh = this.$t('report46.audited')
    }else{
      this.dis = false
      this.sh = this.$t('report46.audit')
    }
    const result1 = await listContentInfo(this.$route.query.id)
    const result2 = await listInfo(this.$route.query.id)
    if (!result2.data.runInfo) {
      result2.data.runInfo = []
    }
    this.shuju = result2.data
    this.airRoom = result2.data.airRoom
    this.postInfo = result2.data.postInfo
    this.review = result2.data.review
    this.airCompInfo = result2.data.airCompInfo
    this.customerInfo = result2.data.customerInfo
    this.completeChecked = result2.data.customerInfo.complete
    this.pic = result1.data
    await this.ListC()
    for (let t = 0; t < this.Menu3.child.length; t++) {
      for (let y = 0; y < this.Menu3.child[t].child.length; y++) {
        const bl = this.Menu3.child[t].child[y]
        if (bl.menuType != '11') {
          const cz = this.pic.find(e => e.propertyName == bl.propertyName)
          bl.qpic = []
          bl.hpic = []
          bl.qtext = ''
          bl.htext = ''
          if (cz) {
            if (cz.content && cz.content.length > 0) {
              if (cz.content.find(ee => ee.contentType == '0')) {
                bl.qtext = cz.content.find(ee => ee.contentType == '0').content
              }
              if (cz.content.find(ee => ee.contentType == '1')) {
                bl.htext = cz.content.find(ee => ee.contentType == '1').content
              }
            }
            cz.pic.forEach(i => {
              if (i.picType == '0') {
                bl.qpic.push(i.picUrl)
              } else {
                bl.hpic.push(i.picUrl)
              }
            })
          }
        } else {
          if(this.shuju[this.Menu3.child[t].propertyName] && this.shuju[this.Menu3.child[t].propertyName].length>0){
                      bl.xj = this.shuju[this.Menu3.child[t].propertyName][0].note
          }

        }
      }
    }
    const tou = this.Menu1.child.find(i => i.propertyName == 'postInfo').render
    tou['1'] = {
      id: '1',
      postModel: this.$t('runningData.model'),
      postType: this.$t('runningData.type'),
      postNum: this.$t('visitRecords.num'),
      c: tou['1'][0].menuContent,
      pT: this.$t('runningData.type')
    }
    this.postInfo.forEach(e => {
      e.pT = tou['1'].c.split(',')[e.postType]
      tou[e.id] = e
    });

    console.log(tou);
  }

};

</script>
<template>
  <div
    class="tableBox"
    ref="print"
    style="position: relative;"
  >
  <div style="position: absolute;right: 140px;top: 70px;font-size: large;">{{ completeChecked }}</div>
    <el-button
      style="position: absolute;right: 220px;top: 20px;"
      type="primary"
      :disabled="!dis"
      @click="printOut('pdfDom')"
    >{{ $t('report46.export') }}PDF</el-button>
    <el-button
      style="position: absolute;right: 125px;top: 20px;"
      type="primary"
      :disabled="dis"
      @click="change"
    >{{ sh }}</el-button>
    <el-button
      style="position: absolute;right: 50px;top: 20px;"
      type="primary"
      @click="$router.push('/46report')"
    >{{ $t('buttons.goBack') }}</el-button>
    <div style="height: 100vh; overflow: auto;">
      <div
        style="width: 800px;margin: 0 auto;"
        id="pdfDom"
      >

        <div style="width: 100%;height: 1131.1px;position: relative;">
          <img
            :src="zhuye"
            style="width: 100%;height: 1131.1px;"
          >
          <div
            style="width: 500px;height: 214px;position:absolute;bottom: 200px;left: 50%;transform: translateX(-50%);font-size: 18px;color: white;"
          >
            <table>
              <tr>
                <td>{{ $t('common.customerName') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.customerInfo.customerName }}</td>
              </tr>
              <tr>
                <td>{{ $t('customer.address') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.customerInfo.address }}</td>
              </tr>
              <tr>
                <td>{{ $t('orders.contactPerson') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.customerInfo.linkMan }}</td>
              </tr>
              <tr>
                <td>{{ $t('device.mobile') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.customerInfo.linkPhone }}</td>
              </tr>
              <tr>
                <td>{{ $t('common.model') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.airCompInfo.machineModel }}</td>
              </tr>
              <tr>
                <td>{{ $t('device.code') }}</td>
                <td>:&nbsp;</td>
                <td>{{ shuju.airCompInfo.machineNumber }}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 空压站基本情况 -->
        <div
          class="table-wrapper"
          style="border-right:1px #4f81bd solid ;"
        >
          <div class="title">{{ Menu1.menuName }}</div>
          <div
            v-for="(ii, index1) in Menu1.child"
            :key="index1"
            :style="{ width: '100%', display: ![12].includes(ii.menuType) ? 'flex' : '' }"
          >
            <div
              class="head"
              v-if="ii.menuType != '12'"
            >{{ ii.menuName }}</div>
            <div
              class="head1"
              v-if="ii.menuType == '12'"
            >{{ ii.menuName }}</div>
            <div style="width: 100%;">
              <template v-if="Array.isArray(ii.render['1'])">
                <div
                  v-for="(iii, index2) in ii.render"
                  :key="index2"
                  style="display: flex;width: 100%;"
                >
                  <div
                    v-for="(iiii, index3) in iii"
                    style="width: 100%;"
                  >
                    <!-- 0单选 -->
                    <div
                      style="display: flex;width: 100%; height: 100%;"
                      v-if="iiii.menuType == '0'"
                    >
                      <div
                        class="qing2"
                        style="font-weight: 800;"
                      >{{ iiii.menuName || '' }}</div>
                      <div class="qing2">
                        <el-radio-group
                          v-model="iiii.radioList"
                          @change="change11"
                        >
                          <el-radio
                            :label="jj"
                            v-for="(j, jj) in iiii.menuContent.split(',')"
                            :key="j"
                          >{{ j }}</el-radio>

                        </el-radio-group>
                      </div>

                    </div>
                    <!-- 1复选 -->
                    <div
                      style="display: flex;width: 100%; height: 100%;"
                      v-if="iiii.menuType == '1'"
                    >
                      <div
                        class="qing2"
                        style="font-weight: 800;"
                      >{{ iiii.menuName || '' }}</div>
                      <div class="qing2">
                        <el-checkbox-group
                          v-model="iiii.selectList"
                          @change="change11"
                        >
                          <el-checkbox
                            :label="jj"
                            v-for="(j, jj) in iiii.menuContent.split(',')"
                            :key="j"
                          >{{ j }}</el-checkbox>
                        </el-checkbox-group>
                      </div>

                    </div>
                    <!-- 2文本 -->
                    <div
                      style="display: flex;width: 100%; height: 100%;"
                      v-if="iiii.menuType == '2'"
                    >
                      <div
                        class="qing2"
                        style="font-weight: 800;"
                      >{{ iiii.menuName || '' }}</div>
                      <div class="qing2">{{ shuju[ii.propertyName] ? shuju[ii.propertyName][iiii.propertyName] : '' }}
                      </div>
                    </div>
                    <!-- 6 -->
                    <div
                      style="width: 100%; height: 100%;"
                      v-if="iiii.menuType == '6'"
                    >
                    <div v-if="shuju[ii.propertyName].length>0">
                      <div
                        class="qing4"
                        style="justify-content: left;"
                        v-for="(w, ww) in shuju[ii.propertyName]"
                      >{{+ww + 1 }}{{ w[iiii.propertyName]}}</div>
                    </div>
                    <div v-else style="height: 100%;width: 100%;">
                      <div
                        class="qing4"
                        style="justify-content: left;height: 100%;"

                      >{{ $t('common.none') }}</div>
                    </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <template v-if="Object.keys(ii.render).length>1">
                <div
                  v-for="(iii, index2) in ii.render"
                  :key="index2"
                  style="display: flex;width: 100%;"
                >

                  <div class="qing3">{{ iii.pT }}</div>
                  <div class="qing3">{{ iii.postModel }}</div>
                  <div class="qing3">{{ iii.postNum }}</div>


                </div>
              </template>
                <template v-else>
                <div
                  v-for="(iii, index2) in ii.render"
                  :key="index2"
                  style="display: flex;width: 100%;"
                >

                  <div class="qing3">{{ iii.pT || ''}}</div>
                  <div class="qing3">{{ iii.postModel || ''}}</div>
                  <div class="qing3">{{ iii.postNum || ''}}</div>


                </div>
                <div

                  style="display: flex;width: 100%;"
                >

                  <div class="qing3">{{ $t('common.none') }}</div>
                  <div class="qing3">{{ $t('common.none') }}</div>
                  <div class="qing3">{{ $t('common.none') }}</div>


                </div>
              </template>
              </template>


            </div>
          </div>
        </div>
        <!-- 综合维护回报价值 -->
        <div
          class="table-wrapper"
          style="border-right:1px #4f81bd solid ;"
        >
          <div class="title">{{ Menu2.menuName }}</div>
          <div
            v-for="(ii, index1) in Menu2.child"
            :key="index1"
            :style="{ width: '100%', display: ![12].includes(ii.menuType) ? 'flex' : '' }"
          >
            <div
              class="head"
              v-if="ii.menuType != '12'"
            >{{ ii.menuName }}</div>
            <div
              class="head1"
              style="background-color: #b8cce4;justify-content: left;padding: 10px 5px;"
              v-if="ii.menuType == '12'"
            >{{ ii.menuName }}</div>
            <div style="width: 100%;">

              <div
                v-for="(iii, index2) in shuju[ii.propertyName]"
                :key="index2"
                style="display: flex;width: 100%;"
              >
                <div style="width: 100%; height: 100%;">
                  <div
                    class="qing4"
                    style="justify-content: left;"
                  >{{+index2 + 1 }}{{ iii.note }}</div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <!-- 空压站工作状态数据 -->
        <div
          class="table-wrapper"
          style="border-right:1px #4f81bd solid ;"
        >
          <div class="title">{{ Menu3.menuName }}</div>
          <div
            v-for="(ii, index1) in Menu3.child"
            :key="index1"
            :style="{ width: '100%', display: ![12].includes(ii.menuType) ? 'flex' : '' }"
          >
            <div class="head">{{ ii.menuName }}</div>
            <div style="width: 100%;">
              <div style="width:calc(100% + 1px) ;display: flex;">
                <div class="qing5">{{ $t('report46.checkItem') }}</div>
                <div class="qing5">{{ $t('report46.range') }}</div>
                <div class="qing5">{{ $t('report46.before') }}</div>
                <div class="qing5">{{ $t('report46.after') }}</div>
              </div>
              <div
                v-for="(iii, index2) in ii.child"
                :key="index2"
                style="width: 100%;"
              >
                <div
                  style="width: 100%; height: 100%;display: flex;"
                  v-if="iii.menuType == '3'"
                >
                  <div class="qing7">{{ iii.menuName }}</div>
                  <div
                    class="qing7"
                    v-html="r(iii.standard)"
                  ></div>
                  <div class="qing9">
                    <div class="qing6">{{ iii.qtext }}</div>
                    <div class="qing10">
                      <img
                        class="picdx"
                        :src="pic"
                        v-for="pic in iii.qpic"
                      >
                    </div>
                  </div>
                  <div class="qing9">
                    <div class="qing6">{{ iii.htext }}</div>
                    <div class="qing10">
                      <img
                        class="picdx"
                        :src="pic"
                        v-for="pic in iii.hpic"
                      >
                    </div>
                  </div>
                </div>

                <div
                  style="width: 100%; height: 100%;display: flex;"
                  v-if="iii.menuType == '5'"
                >
                  <div class="qing7">{{ iii.menuName }}</div>
                  <div
                    class="qing7"
                    v-html="r(iii.standard)"
                  ></div>
                  <div class="qing7">{{ iii.qtext }}</div>
                  <div class="qing7">{{ iii.htext }}</div>
                </div>
                <div
                  style="width: 100%; height: 100%;display: flex;"
                  v-if="iii.menuType == '4'"
                >
                  <div class="qing7">{{ iii.menuName }}</div>
                  <div
                    class="qing7"
                    v-html="r(iii.standard)"
                  ></div>
                  <div class="qing9">
                    <div class="qing10">
                      <img
                        class="picdx"
                        :src="pic"
                        v-for="pic in iii.qpic"
                      >
                    </div>
                  </div>
                  <div class="qing9">
                    <div class="qing10">
                      <img
                        class="picdx"
                        :src="pic"
                        v-for="pic in iii.hpic"
                      >
                    </div>
                  </div>
                </div>
                <div
                  style="width: 100%; height: 100%;display: flex;"
                  v-if="iii.menuType == '11'"
                >
                  <div class="xj1">{{ iii.menuName }}</div>
                  <div
                    class="xj2"
                    v-html="r(iii.xj || '')"
                  ></div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- 综合维护耗材信息 -->
        <div
          class="table-wrapper"
          style="border-right:1px #4f81bd solid ;"
        >
          <div class="title">{{ Menu4.menuName }}</div>
          <div
            v-for="(ii, index1) in Menu4.child"
            :key="index1"
          >

            <div style="width:calc(100% + 1px); display: flex;">

              <div
                v-for="(iii, index2) in ii.child"
                :key="index2"
                style="width: 100%;"
              >
                <div
                  class="qing12"
                  :style="{ borderRight: index2 === ii.child.length - 1 ? '1px solid #4f81bd' : 'unset' }"
                >{{ iii.menuName }}</div>
              </div>
            </div>
            <div
              v-for="(iiii, index2) in shuju[ii.propertyName]"
              :key="index2"
              style="width:calc(100% + 1px); display: flex;"
            >
              <div class="qing13">{{ iiii.productCode }}</div>
              <div class="qing13">{{ iiii.productName }}</div>
              <div class="qing13">{{ iiii.unitName }}</div>
              <div class="qing13">{{ iiii.qty }}</div>
              <div class="qing13">{{ iiii.productModel }}</div>
            </div>
          </div>
        </div>
        <!-- 客户评价 -->
        <div
          class="table-wrapper"
          style="border-right:1px #4f81bd solid ;"
        >
          <div class="title">{{ Menu5.menuName }}</div>
          <div
            v-for="(ii, index1) in Menu5.child"
            :key="index1"
          >

            <div style="width:calc(100% + 1px); display: flex;">

              <div style="width: 100%;display: flex;">
                <div
                  class="qing14"
                  v-if="ii.child[0].menuType == '9'"
                  style="padding: 0px 10px;"
                >
                  {{ $t('report46.starRating') }}
                  <el-radio-group
                    v-model="shuju[ii.propertyName][ii.child[0].propertyName]"
                    style="height: 100%;display: flex;flex-direction: column;"
                  >
                    <el-radio :label="5">★★★★★</el-radio>
                    <el-radio :label="4">★★★★</el-radio>
                    <el-radio :label="3">★★★</el-radio>
                    <el-radio :label="2">★★</el-radio>
                    <el-radio :label="1">★</el-radio>
                  </el-radio-group>
                </div>
                <div
                  class="qing14"
                  style="padding: 0px 10px;"
                >
                {{ $t('report46.remark') }}
                  {{ shuju[ii.propertyName][ii.child[1].propertyName] }}
                </div>
                <div
                  class="qing14"
                  style="padding: 0px 10px;"
                >
                {{ $t('report46.customerSignature') }}<br>
                  <img
                    style="width: 50px;height: 50px;"
                    :src="shuju[ii.propertyName][ii.child[2].propertyName]"
                  >
                  <br>
                  {{ $t('warningForm.phoneNumber') }}:  <br>
                  {{ shuju.customerInfo.linkPhone }}
                </div>
                <div class="qing14">
                  <div class="qing15">
                    {{ $t('report46.reportCode') }}{{ shuju[ii.propertyName][ii.child[3].propertyName] }}
                  </div>
                  <div class="qing15">
                    {{ $t('warningForm.phoneNumber') }}: {{ shuju[ii.propertyName][ii.child[4].propertyName] }}
                  </div>
                  <div style=" width: 100%;
  height: 33.33%;

  font-size: 16px;
  padding: 10px 10px;
  color: black;
  word-break: break-word;">
  {{ $t('binding.serviceMan') }}：
                    <br>
                    {{ shuju[ii.propertyName][ii.child[5].propertyName] }}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>

  </div>
</template>


<style lang="less" scoped>
.title {
  width: 100%;
  height: 45px;
  background-color: #4f81bd;
  text-align: center;
  padding: 10px 0;
  color: white;
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 3px;
}

table {
  border-collapse: separate;
  /* default */
  border-spacing: 0;
  border-top: 1px solid #fff;
  border-left: 1px solid #fff;
}

th,
td {
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;

}

td:nth-child(1) {
  text-align-last: justify;
}

td:not(:nth-child(2)) {
  padding: 4px 10px;
}

td:nth-child(3) {
  width: 350px;
}

.head {
  width: 10%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 10px;
  font-weight: 800;
}

.head1 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qing2 {
  width: 50%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qing4 {
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qing3 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qing5 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b8cce4;
  color: black;
  font-weight: 600;
}

.qing7 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;

}

.qing8 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: black;

}

.qing6 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: black;

}

.qing10 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  height: 100%;
  padding: 5px 5px;
  flex: 1;



}

.qing9 {
  width: 100%;
  font-size: 16px;
  color: black;
  display: flex;
  flex-direction: column;
}

.picdx {
  width: 100%;
  height: 140px;
}

.xj1 {
  width: 25%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  display: flex;
  justify-content: center;
  align-items: center;

}

.xj2 {
  width: 75%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
}

.qing12 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b8cce4;
  color: black;
  font-weight: 600;
}

.qing12:last-child {
  border-right: 1px #4f81bd solid;
}

.qing13 {
  width: 20%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  word-break: break-word;
}

.qing14 {
  width: 100%;
  border-bottom: 1px #4f81bd solid;
  border-left: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 0px;

  color: black;
  word-break: break-word;
}

.qing15 {
  width: 100%;
  height: 33.33%;
  border-bottom: 1px #4f81bd solid;
  font-size: 16px;
  padding: 10px 10px;
  color: black;
  word-break: break-word;
}

body {

  height: 1000vh;
}</style>
